<template>
    <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 33.0537C8 31.77 8.96095 30.7264 10.1426 30.7264H16.6665L13.4179 34.2736H26.4184L32.9173 26H47L37.6059 37.274C36.8112 38.2271 35.2147 39 34.027 39H10.1395C8.96157 39 8.00481 37.9604 8 36.674V33.0537Z" fill="#00549D"/>
        <path d="M52.9988 27.5243C52.9988 28.7071 52.0482 29.6661 50.8636 29.6661L43.5495 29.6662L46.5119 26.4167H32.4582L27.0525 34H13L22.4412 22.646C23.1983 21.737 24.7648 21 25.9336 21H50.877C52.0495 21 53 21.9602 53 23.1416V27.5232L52.9988 27.5243Z" fill="#FFD800"/>
    </svg>
</template>

<script>
export default {
    name: 'icon-bancontact'
}
</script>